import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Dropdown,
  Input,
  Menu,
  PageHeader,
  Row,
  Space,
  Spin,
  Statistic,
  Table,
  Tag
} from "antd";
import { Component } from "react";
import Highlighter from "react-highlight-words";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { DELETE, GET, UPDATE } from "../constants/request-type";
import {
  delete_deliverman,
  deliverman,
  get_all_deliverman,
  update_deliverman
} from "../constants/routes";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";
import { openNotificationWithIcon } from "../functions/notification";

import GoogleMapReact from "google-map-react";
import { google_map_key } from "../constants/mapkey";

import { CSVLink } from "react-csv";

import logger from "../../utils/logger.js";
const token = sessionStorage.getItem("auth_token");

const { RangePicker } = DatePicker;

class Deliverman extends Component {
  state = {
    selectedRowKeys: [],
    searchText: "",
    searchedColumn: "",
    load: true,
    data: [],
    list: [],
    start: null,
    end: null,
    driver_around: [],
    openModal: false,
    driver_selected: null,
    selected: true,
    overall: true,
    allowed: false,
    blocked: false
  };

  componentDidMount() {
    this.getData();
  }

  static defaultProps = {
    center: {
      lat: 43.65107,
      lng: -79.347015
    },
    zoom: 5
  };

  getData = async () => {
    const request_details = {
      type: GET,
      url: service_api,
      route: deliverman + "/" + get_all_deliverman,
      data: null,
      token: token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      this.setState({
        load: false,
        data: decryptSingleData(response.data.deliverman)
      });
    } catch (err) {
      this.setState({ load: false });
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  handleStatus = async (id, status) => {
    const data = {
      status: status
    };
    const request_details = {
      type: UPDATE,
      url: service_api,
      route: deliverman + "/" + update_deliverman + "/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  handleVerified = async (id, status) => {
    const data = {
      verified: status
    };

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: deliverman + "/" + update_deliverman + "/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  handleWorking = async (id, status) => {
    const data = {
      working: status
    };

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: deliverman + "/" + update_deliverman + "/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  handleTrip = async (id, status) => {
    const data = {
      on_trip: status
    };

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: deliverman + "/" + update_deliverman + "/" + id,
      data: data,
      token: token
    };

    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon("error", `${err.response.data}`);
    }
  };

  onSelectChange = (selectedRowKeys) => {
    logger.log("selectedRowKeys changed: ", selectedRowKeys);
    this.setState({ selectedRowKeys });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      )
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleDelete = async (id) => {
    const request_details = {
      type: DELETE,
      url: service_api,
      route: deliverman + "/" + delete_deliverman + "/" + id,
      token: token
    };
    try {
      await MakeRequestAsync(request_details);
      return setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      return openNotificationWithIcon(
        "error",
        `${err?.response?.data?.message}`
      );
    }
  };

  render() {
    const columns = [
      {
        title: "Id",
        dataIndex: "_id",

        ...this.getColumnSearchProps("_id")
      },
      {
        title: "En ligne",
        dataIndex: "working",
        render: (text) => (
          <Tag color={text === true ? "green" : "volcano"}>
            {text === true ? "Oui" : "Non"}
          </Tag>
        )
      },
      {
        title: "En course",
        dataIndex: "on_trip",
        render: (text) => (
          <Tag color={text === true ? "green" : "volcano"}>
            {text === true ? "Oui" : "Non"}
          </Tag>
        )
      },
      {
        title: "Profil",
        dataIndex: "pic",
        render: (text) => (
          <a href={text} target="_blank" rel="noreferrer">
            <img
              src={text}
              style={{
                width: 60,
                height: 60,
                objectFit: "contain"
              }}
              alt="driver-profil"
            />
          </a>
        )
      },
      {
        title: "Nom",
        dataIndex: "firstname",
        render: (text) => <span>{text}</span>
      },
      {
        title: "Lastname",
        dataIndex: "lastname",
        render: (text) => <span>{text}</span>
      },
      {
        title: "Documents",
        dataIndex: "document",
        render: (text, record) => (
          <Tag color={"purple"}>
            {record.driving_license === null ? (
              "Aucun permis"
            ) : (
              <a href={record.driving_license} target="_blank" rel="noreferrer">
                Permis de conduire
              </a>
            )}
            <br />
            {record.bike_document === null ? (
              "Aucun document"
            ) : (
              <a href={record.bike_document} target="_blank" rel="noreferrer">
                Document engin
              </a>
            )}
            <br />
            {record.bike_insurance === null ? (
              "Aucune assurance"
            ) : (
              <a href={record.bike_insurance} target="_blank" rel="noreferrer">
                Assurance
              </a>
            )}
            <br />
            {record.working_permit === null ? (
              "Aucune autorisation de travail"
            ) : (
              <a href={record.working_permit} target="_blank" rel="noreferrer">
                Autorisation de travail
              </a>
            )}
          </Tag>
        )
      },
      {
        title: "Verfier ?",
        dataIndex: "verified",
        render: (text) => (
          <Tag color={text === true ? "green" : "red"}>
            <b>
              {text === true && "Actif"}
              {text === false && "Inactif"}
            </b>
          </Tag>
        )
      },
      {
        title: "Status",
        dataIndex: "status",
        render: (text) => (
          <Tag color={text === true ? "green" : "red"}>
            <b>
              {text === true && "Actif"}
              {text === false && "Inactif"}
            </b>
          </Tag>
        )
      },
      {
        title: "Actions",
        fixed: "right",
        render: (text, record) => (
          <div>
            <Dropdown
              overlay={MenuButton(record)}
              placement="bottomCenter"
              arrow
            >
              <Button>Options</Button>
            </Dropdown>
          </div>
        )
      }
    ];

    const MenuButton = (record) => (
      <Menu>
        {record.on_trip === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleTrip(record._id, true)}>
              Activer en course
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleTrip(record._id, false)}>
              Désactiver en course
            </Link>
          </Menu.Item>
        )}

        {record.working === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleWorking(record._id, true)}>
              Mettre en ligne
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleWorking(record._id, false)}>
              Passer hors-ligne
            </Link>
          </Menu.Item>
        )}
        {record.verified === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleVerified(record._id, true)}>
              Verifier le compte
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleVerified(record._id, false)}>
              Retirer la verification
            </Link>
          </Menu.Item>
        )}

        {record.status === false ? (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, true)}>
              Activer
            </Link>
          </Menu.Item>
        ) : (
          <Menu.Item>
            <Link onClick={() => this.handleStatus(record._id, false)}>
              Desactiver
            </Link>
          </Menu.Item>
        )}

        <Menu.Item>
          <Link onClick={() => this.handleDelete(record._id)}>Supprimer</Link>
        </Menu.Item>
      </Menu>
    );

    const AnyReactComponent = ({ driver_data }) => (
      <div
        onClick={() => {
          this.setState({ openModal: true, driver_selected: driver_data });
        }}
      >
        <img
          src={require("../../assets/bike.png")}
          style={{ width: 30, height: 30 }}
          alt="bike-icon"
        />
      </div>
    );

    const { load, data, start, end } = this.state;
    return (
      <>
        <PageHeader
          title="Commandes"
          tags={<Tag color="blue">Liste des commandes</Tag>}
          subTitle=""
          extra={[
            <RangePicker
              showTime
              onChange={(data) => {
                logger.log(data);
                if (data === null) {
                  this.setState({
                    start: null,
                    end: null
                  });
                }
                let d1 = data[0].format("YYYY-MM-DDTHH:mm:ss");
                let d2 = data[1].format("YYYY-MM-DDTHH:mm:ss");

                this.setState({ start: d1, end: d2 });
              }}
            />,
            <CSVLink data={data}>Exporter CSV/Excel</CSVLink>,

            <Button
              onClick={() => {
                this.setState({ driver_selected: null, load: true });
                this.getData();
              }}
            >
              Actualiser
            </Button>,
            <Button
              onClick={() => {
                this.setState({ driver_selected: null });
              }}
            >
              Rétablir
            </Button>
          ]}
        >
          <Row>
            <Statistic
              title="Total"
              value={
                data?.filter((item) => {
                  if (start === null || end === null) {
                    return item;
                  }
                  return item.createdAt >= start && item.createdAt <= end;
                }).length
              }
            />
          </Row>

          <Row
            style={{
              marginTop: 20
            }}
          >
            <div
              id="mapping"
              style={{ height: "35vh", width: "100%", marginTop: 10 }}
            >
              <GoogleMapReact
                bootstrapURLKeys={{ key: google_map_key }}
                defaultCenter={this.props.center}
                defaultZoom={this.props.zoom}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={this.handleGoogleMapApi}
              >
                {this.state.data
                  ?.filter((item) => {
                    return (
                      item.position.lat !== null && item.position.lng !== null
                    );
                  })
                  ?.map((res) => (
                    <AnyReactComponent
                      lat={res?.position?.lat}
                      lng={res?.position?.lng}
                      driver_data={res}
                    />
                  ))}
              </GoogleMapReact>
            </div>
            {load ? (
              <Space size="middle">
                <Spin size="large" />
              </Space>
            ) : (
              <Col
                span={24}
                style={{
                  marginTop: 20
                }}
              >
                <Table
                  scroll={{
                    x: "auto"
                  }}
                  columns={columns}
                  dataSource={data?.filter((item) => {
                    if (start === null || end === null) {
                      return item;
                    }
                    return item.createdAt >= start && item.createdAt <= end;
                  })}
                />
              </Col>
            )}
          </Row>
        </PageHeader>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    admin: state.admin
  };
};

const mapDispatchStoreToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchStoreToProps)(Deliverman);
